

export function convertSize(bytes, options = {}) {
        const {separator = " ", farsi, fixed} = options;
        const defaultSizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const farsiSizes = ['بایت', 'کیلوبایت', 'مگابایت', 'گیگابایت', 'ترابایت'];
        const sizes = farsi ? farsiSizes : defaultSizes;
        if (bytes === 0) return 'حجم نامشخص'
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
        if (i === 0) return `${bytes}${separator}${sizes[i]}`
        return `${(bytes / (1024 ** i)).toFixed(fixed ? 0 : 1)}${separator}${sizes[i]}`
}